"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollbox = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const ScrollArea_1 = require("../ScrollArea");
const viewportClass = (0, nano_theme_1.rule)({
    fl: '1 1 auto',
    minH: 0,
    w: '100%',
    bxz: 'border-box',
    ovy: 'auto',
    scrollbarWidth: 'none',
    MsOverflowStyle: 'none',
    overscrollBehavior: 'contain',
    '&::-webkit-scrollbar': { d: 'none' },
});
const ScrollboxViewport = ({ children }) => {
    const state = (0, ScrollArea_1.useScrollArea)();
    return (React.createElement("div", { ref: state.setViewport, className: viewportClass }, children));
};
const Scrollbox = ({ children, shadow = true, ...rest }) => {
    return (React.createElement(ScrollArea_1.ScrollArea, { shadow: shadow, railWidth: 4, ...rest },
        React.createElement(ScrollboxViewport, null, children),
        React.createElement(ScrollArea_1.ScrollRail, null)));
};
exports.Scrollbox = Scrollbox;
